"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const react_i18next_1 = require("react-i18next");
const i18next_resources_to_backend_1 = __importDefault(require("i18next-resources-to-backend"));
const defaultLng = "nl";
let lng = defaultLng;
// TODO: move loadPath to unified back-end
i18next_1.default
    .use((0, i18next_resources_to_backend_1.default)((language, namespace, callback) => {
    Promise.resolve().then(() => __importStar(require(`./locales/${language}.json`))).then((resources) => {
        callback(null, resources);
    })
        .catch((error) => {
        callback(error, null);
    });
}))
    .use(react_i18next_1.initReactI18next)
    .init({
    lng,
    debug: false,
    keySeparator: false,
    interpolation: {
        escapeValue: false,
    },
    react: {
        wait: true,
        useSuspense: true,
    },
});
exports.default = i18next_1.default;
//# sourceMappingURL=i18n.js.map